module.exports = __webpack_public_path__ + "static/img/SPL.0e05b96.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPL.png
// module id = pGBG
// module chunks = 1